/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataSourcesRequestPost } from '../../models/data-sources-request-post';
import { DataSourcesResponse } from '../../models/data-sources-response';

export interface DataControllerDataSources$Params {
  referer?: string;
      body: DataSourcesRequestPost
}

export function dataControllerDataSources(http: HttpClient, rootUrl: string, params: DataControllerDataSources$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourcesResponse>> {
  const rb = new RequestBuilder(rootUrl, dataControllerDataSources.PATH, 'post');
  if (params) {
    rb.header('referer', params.referer, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataSourcesResponse>;
    })
  );
}

dataControllerDataSources.PATH = '/planning-projects/v1-preview/data/data-sources';
